export function isSuccess(statusCode) {
    return statusCode >= 200 && statusCode < 300
}
